// extracted by mini-css-extract-plugin
export default {"item":"status-item_item__FeeJD","title":"status-item_title__a06rs","subTitle":"status-item_subTitle__d3a04"};